import { z } from "zod";
export var propertySchema = z.object({
    id: z.string().optional(),
    name: z.string(),
    country: z.string(),
    description: z.string(),
    version: z.number(),
    hasStructure: z.boolean(),
    needPublish: z.boolean().optional(),
    numberOfStructures: z.boolean().optional(),
    projects: z.any().optional()
});
//# sourceMappingURL=Property.zod.js.map